import { render } from "./PlatformEmailTemplatesCard.vue?vue&type=template&id=77c05a36&scoped=true"
import script from "./PlatformEmailTemplatesCard.vue?vue&type=script&lang=js"
export * from "./PlatformEmailTemplatesCard.vue?vue&type=script&lang=js"

import "./platformEmail.css?vue&type=style&index=0&id=77c05a36&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c05a36"]])

export default __exports__